import { cx } from '@clutch-creator/bridge';

export default (props, vars) => cx('loadingSpinner', props?.['className']);
